import { ANALYTIC_COOKIES } from '../constants'
import { getFromSessionStorageWithExpiry } from '../getFromSessionStorageWithExpiry'

export const getPreviousPageUrl = () => {
  return getFromSessionStorageWithExpiry(ANALYTIC_COOKIES.PREVIOUS_PAGE_URL)
}
